// extracted by mini-css-extract-plugin
export default {"concert":"singleConcertToDelete_concert__0Ku3W","datum":"singleConcertToDelete_datum__JvFMD","titel":"singleConcertToDelete_titel__O9CLm"};